import { FormField, Select } from '@cloudscape-design/components'
import { NonCancelableEventHandler } from '@cloudscape-design/components/internal/events'
import { BaseChangeDetail } from '@cloudscape-design/components/input/interfaces'

export type LabeledSelectProps = {
    label?: string,
    value: string, 
    options: string | Array<string>,
    onChange: NonCancelableEventHandler<BaseChangeDetail>, 
    validate?: (value: string, label: string) => boolean,
    readOnly?: boolean, 
    [rest: string]: any,
}

export default ({ label = "", value, options, onChange, validate, readOnly = false, ...rest }: LabeledSelectProps) => {

    const valid = (!readOnly && validate) ? validate(value, label) : true

    let strings = (typeof options === 'string') ? options.split(';') : options
    if (!options) strings = ["Loading..."]
    const opts = (typeof strings[0] === 'string') ? strings.map((option: string) => ({value: option, label: option})) : strings
    const selected = opts?.find(o => o?.value === value)

    return (
        <FormField label={label} info={!validate && label ? 'Optional' : ''} >
            <Select selectedOption={selected ?? {value: "", label: ""}}
                onChange={({ detail }) => {
                    onChange({ detail: {value: detail.selectedOption.value ?? ""}})}}
                options={opts}
                invalid={!readOnly && validate && !valid}
                readOnly={readOnly}
                {...rest}
            />
        </FormField> 
    )
}